import { jsxs as c, jsx as n } from "react/jsx-runtime";
import { c as o } from "../../../../clsx-OuTLNxxd.js";
import { I as w } from "../../../../icon-BnqXyiyH.js";
import "../../icon/iconsList.js";
import { useTextarea as b } from "./textarea.hook.js";
const y = "_container_k248c_29", B = "_filled_k248c_43", C = "_error_k248c_46", j = "_success_k248c_49", I = "_counter_k248c_126", e = {
  container: y,
  "group-label": "_group-label_k248c_34",
  filled: B,
  error: C,
  success: j,
  "helper-text": "_helper-text_k248c_52",
  "container-counter-icon": "_container-counter-icon_k248c_105",
  "container-icon": "_container-icon_k248c_112",
  "icon-error-warning-fill": "_icon-error-warning-fill_k248c_117",
  counter: I,
  "dialog-overlay-show": "_dialog-overlay-show_k248c_1",
  "dialog-content-show": "_dialog-content-show_k248c_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_k248c_1"
};
function $({
  id: _,
  disabled: t = !1,
  status: r,
  title: l,
  helperText: i,
  placeholder: u,
  maxLength: a,
  onChange: k,
  onBlur: p,
  message: d,
  value: m,
  defaultValue: h,
  name: f
}) {
  const {
    valueCounter: s,
    isOnBlur: g,
    handleBlur: N,
    handleChange: x,
    hasLabelOrHelperText: v
  } = b(l, i, m, h, k, p);
  return /* @__PURE__ */ c("div", { className: e.container, children: [
    v && /* @__PURE__ */ c("div", { className: e["group-label"], children: [
      l && /* @__PURE__ */ n(
        "label",
        {
          htmlFor: _,
          className: o(r && e[r], (s > 0 && g || t) && e.filled),
          children: l
        }
      ),
      i && /* @__PURE__ */ n("div", { className: e["helper-text"], children: i })
    ] }),
    /* @__PURE__ */ n(
      "textarea",
      {
        id: _,
        name: f,
        "aria-label": "textarea",
        placeholder: u,
        onChange: x,
        className: o(r && e[r]),
        value: m,
        defaultValue: h,
        disabled: t,
        onBlur: N
      }
    ),
    /* @__PURE__ */ c("div", { className: e["container-counter-icon"], children: [
      d && r && /* @__PURE__ */ c("div", { className: e["container-icon"], children: [
        /* @__PURE__ */ n(
          w,
          {
            name: `${r === "error" ? "error-warning-fill" : "checkbox-fill"}`,
            size: "medium",
            className: o(e[r])
          }
        ),
        /* @__PURE__ */ n("span", { className: e[r], children: d })
      ] }),
      a && /* @__PURE__ */ c("div", { className: o(e.counter, s > a && e.error), children: [
        s,
        "/",
        a
      ] })
    ] })
  ] });
}
export {
  $ as Textarea
};
